// extracted by mini-css-extract-plugin
module.exports = {"subscribe-content-wrapper":"_3siGp"};